define('modules/Cart/CartToolsPunchout',[
    'jquery',    
    'global/all',
    './CartManager'
], function ($, Roc, CartManager) {
    
    var returnURL = '';

    var btns = {
        punchIn: '#btnPunchIn',
        clearCart: '#btnClearCart'
    };

    function punchInEvt() {
        $(document).on('click', btns.punchIn, $.proxy(function () {
            
                Roc.Core.lockButton(btns.forgotPass);
                //var requestData = Roc.Validation.getFieldValues(forms.ForgotPassword);

                $.ajax({
                    url: '/ajax/P2GoPunchIn/?returnUrl=' + encodeURIComponent(returnURL),
                    type: 'GET',
                    //data: JSON.stringify(requestData),
                    //contentType: 'application/json',
                    dataType: 'json',
                    complete: function (xhr) {
                        var response = xhr.responseJSON || {};
                        if (response.success) {
                            document.location = returnURL + '?redirect=1'
                        }

                        if (response.errorMessage) {
                            $errorContainer.html(response.errorMessage);
                        }
                        Roc.Core.releaseLockedButton(btns.forgotPass);
                        Roc.EventManager.notify(Roc.Events.users.FORGOT_PASSWORD, xhr);
                    }
                });
        }, this));
        }

        function clearCartEvt() {

            $(document).on('click', btns.clearCart, $.proxy(function () {
            var deferred = $.Deferred();

            Roc.UI.confirm({
                "title": 'Clear Cart',
                "message":
                    'Would you like to clear all items currently in your cart ?',
                "buttons": {
                    "Continue": {
                        "class": 'btn btnAction confirm unlockCartButton',
                        "autoClose": false,
                        "action": function () {
                            Roc.Core.lockButton('.unlockCartButton');
                            removeCurrentCart()
                                .then(
                                    function () {
                                        deferred.resolve();
                                        $('.closeCartLockerModal').trigger('click');
                                        window.location.reload(true);
                                    },
                                    function () {
                                        deferred.reject();
                                    });
                        }
                    },
                    "Cancel": {
                        "class": 'btn closeCartLockerModal',
                        "action": function () {
                            deferred.reject();
                        }
                    }
                }
            });
            }, this));
        }


        function removeCurrentCart() {
            return $.ajax({
                url: '/ajax/ClearCurrentCart',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json'
            });
        }


    function bindEvents() {
        punchInEvt();
        clearCartEvt();
    }
    function init(options) {
        returnURL = options.returnURL;
        bindEvents();
    }
    var CartToolsPunchout = {
        init: init,
    };

    Roc.Logger.debug('CartToolsPunchout.js Loaded:', CartToolsPunchout);

    return CartToolsPunchout;
});
